// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dialog-history"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M11 14C11 17.3137 13.6863 20 17 20C20.3137 20 23 17.3137 23 14C23 10.6863 20.3137 8 17 8C13.6863 8 11 10.6863 11 14Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 4H23M1 9H7M1 14H7M1 19H7","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17 12.336V13.9999L18.3333 15.3334M17 20C13.6863 20 11 17.3137 11 14C11 10.6863 13.6863 8 17 8C20.3137 8 23 10.6863 23 14C23 17.3137 20.3137 20 17 20Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DialogHistoryIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dialog-history',
    ref,
    icon: element,
  },
));

DialogHistoryIcon.displayName = 'DialogHistoryIcon';

export default DialogHistoryIcon;
